import * as React from 'react';
import * as intl from "react-intl-universal";
import { NavLink } from 'react-router-dom';
import { CopyOutlined, LoginOutlined } from '@ant-design/icons';
import { Col, Popover, Row, Tooltip } from 'antd';
import Formatter from '../../common/utils/formatter';
import Item from '../../common/app/Business/EncryptItem';
import Clipboard from '../../common/components/Clipboard';
import Loading from '../../common/components/Loading';
import Image from '../../common/components/Image';
import { get } from 'common/utils/request';
import { connect } from 'react-redux';

interface iProps {
    dataSource?: any;
    roleMap: any;
    trigger?: "click" | "hover";
    link?: string;
    extra?: Array<any>;
    id?: string;
    type?: 'sales' | 'client' | 'admin' | 'ib';
    menu?: Array<any>;
    status?: {
        utype: string;
    };
}

const mapStateToProps = (state: any) => {
    const status = state.user.get('status').size
        ? { utype: state.user.get('status').get('utype') }
        : state.user.get('status');
    return {
        status,
        menu: state.system.get('menu'),
    };
};

@Clipboard()
class CopyText extends React.Component<{
    text: string,
    clipboard?: any
}> {
    render() {
        const { text, clipboard } = this.props;
        return (
            <Tooltip placement='topLeft' title={intl.get('Global.Copy')}>
                <a onClick={() => clipboard.copy(text)}> <CopyOutlined /></a>
            </Tooltip>
        );
    }
}

export function Link(props: any) {
    if (!props || !props.link) return '-';
    const { firstname, lastname, className, link } = props;
    const name = intl.get('Global.Name', {
        firstName: firstname,
        lastName: lastname
    });
    return <NavLink className={className} to={link} title={name}>{name}</NavLink>;
}

@(connect(mapStateToProps) as any)
export default class Popper extends React.Component<iProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            dataSource: {},
            authorities: {},
            showBool: false,
            isLoading: true
        };
    }

    /**
     * 权限信息处理
     */
    getAuthorities = (routes: any) => {
        return (routes || [])
            .reduce((prev: any, { key, children }: any) => ({
                ...prev,
                [key.match(/[A-Za-z0-9]+$/)[0]]: (children && children.length) ? this.getAuthorities(children) : true
            }), {});
    };

    // 初始化数据
    intlData = async () => {
        const { id, dataSource, type, menu, status: { utype: curUtype } } = this.props;
        const clientChildren = menu && menu.find(({ key }: any) => key === 'CLIENT').children || [];
        const tree = this.getAuthorities(clientChildren);
        const authorities = curUtype === 'admin'
            ? tree.ACCOUNT && tree.ACCOUNT.CRM && tree.ACCOUNT.CRM.DETAIL && tree.ACCOUNT.CRM.DETAIL.BASIC
            : tree.MANAGER && tree.MANAGER.LIST && tree.MANAGER.LIST.DETAIL;
        // 查看管理员角色信息 始终显示
        if (type === 'admin') {
            authorities.PHONE = true;
            authorities.EMAIL = true;
        }
        // 销售端可以查看所属下级和客户手机和邮箱
        if (curUtype === 'sales') {
            authorities.EDITEMAIL = true;
            authorities.EDITPHONE = true;
        }
        let data = {};
        if (id && type) {
            switch (type) {
                case 'client':
                    data = await get('/v2/client/crm/show', { uuid: id });
                    break;
                case 'ib':
                case 'sales':
                    data = await get('/v2/sales/account/show', { uuid: id });
                    break;
                case 'admin':
                    data = await get('/v2/user/admin/show', { uuid: id });
                    break;
            }
            this.setState({
                authorities,
                dataSource: data || {},
                isLoading: false
            });
        }
        else {
            this.setState({
                authorities,
                dataSource,
                isLoading: false
            });
        }
    };
    /**
     * format
     */
    format = (type: "email" | "phone", value: string, uuid: string, utype: string) => {
        const { authorities } = this.state;
        const val = value.indexOf("*") < 0
            ? Formatter.contact.formatContact(type, value)
            : value;
        const actionLink: any = {
            client: '/v2/client/crm/decrypt',
            ib: '/v2/client/crm/decrypt',
            sales: '/v2/sales/account/decrypt',
            admin: '/v2/user/admin/decrypt',
        };
        let isDisable = false;
        if (type === 'email' && !authorities.EDITEMAIL) isDisable = true;
        if (type === 'phone' && !authorities.EDITPHONE) isDisable = true;
        return isDisable
            ? val
            : <Item action={actionLink[utype]} value={val} config={{ uuid, type }} onlyPhone={true} style={{ maxWidth: 130 }} />;
    };

    /**
     * 获取内容
     */
    getConfig = (): any => {
        const { extra, status: { utype: curUtype } } = this.props;
        const { dataSource, authorities } = this.state;
        const { create_time, uphone, uemail, uphonecode, uuid, agent_info, sales_info, sales, utype, client_source } = dataSource;
        return [{
            key: 'uuid',
            label: intl.get('Global.AccountId'),
            value: uuid,
            Extra: (value: string) => <CopyText text={value} />
        },
        {
            key: 'regTime',
            label: intl.get('Global.RegTime'),
            value: Formatter.time.value(create_time),
        },
        authorities.PHONE && {
            key: 'phone',
            label: intl.get('Global.Phone'),
            value: (!!uphonecode && !!uphone)
                ? <span style={{ display: "flex", alignItems: "center" }}><span style={{
                    marginRight: 5
                }}>{uphonecode}</span> {this.format("phone", uphone, uuid, utype)}</span>
                : '-'
        },
        authorities.EMAIL && {
            key: 'email',
            label: intl.get('Global.Email'),
            value: uemail
                ? <span>{this.format("email", uemail, uuid, utype)}</span>
                : '-'
        },
        (utype === 'client' || utype === 'ib') && {
            key: 'agent',
            label: intl.get('Client.CrmIntroAgent'),
            value: agent_info
                ? <span>{intl.get('Global.Name', {
                    firstName: agent_info.firstname,
                    lastName: agent_info.lastname
                })}</span> : '-'
        },
        (utype === 'client' || utype === 'ib') && {
            key: 'sales',
            label: intl.get('Global.SupSales'),
            value: sales_info
                ? <span>{intl.get('Global.Name', {
                    firstName: sales_info.firstname,
                    lastName: sales_info.lastname
                })}</span> : '-'
        },
        utype === 'sales' && {
            key: 'sales',
            label: intl.get('Global.SupSales'),
            value: sales
                ? <span>{intl.get('Global.Name', {
                    firstName: sales.firstname,
                    lastName: sales.lastname
                })}</span> : '-'
        },
        curUtype === 'admin' && (utype === 'client' || utype === 'ib') && {
            key: 'client_source',
            label: intl.get('Global.ClientSource'),
            value: this.showClientSource(client_source)
        }
        ].concat(extra || [] as any).filter((item) => {
            return !!item;
        });
    };

    showClientSource = (value: 'website' | 'agent_link' | 'sales_link' | 'import' | 'admin' | 'sales_clue' | 'passport' | 'followme' | 'official' | 'billboard' | 'intrade_app') => {
        return {
            website: intl.get('Sales.ClueDomainAccess'),
            agent_link: intl.get('Sales.ClueAgentLink'),
            sales_link: intl.get('Sales.ClueSalesLink'),
            import: intl.get('SignUp.SourceDataImport'),
            admin: intl.get('Sales.ClueCreateByAdmin'),
            sales_clue: intl.get('Sales.TitleSalesClue'),
            passport: intl.get('Sales.PassPage'),
            followme: 'Followme',
            official: intl.get('Sales.ClueOfficialWebsite'),
            billboard: intl.get('Sales.ClueInvesting'),
            intrade_app: 'Intrade App',
        }[value] || intl.get('SignUp.Sourceorder', { filed: value });
    };

    getAvatar = (config: any) => {
        const { lastName, firstName, roleName, uhead, style, className, showUser } = config;
        return <span className={className}>
            <Image className='Avatar' url={uhead} style={{
                verticalAlign: 'middle',
                width: `${showUser ? '2.14rem' : '2rem'}`,
                height: `${showUser ? '2.14rem' : '2rem'}`,
                ...style
            }} fallbackUrl={window.config.img_file(`/images/icons/avatar.png`)} />
            {showUser && <span key='user' className="User">
                <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <span className="User-name" style={{ maxWidth: "400px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }} title={intl.get('Global.Name', { firstName, lastName })}>{intl.get('Global.Name', { firstName, lastName })}</span>
                    <span className="User-role" title={roleName}>{roleName}</span>
                </span>
            </span>}
        </span>;
    };

    /**
     * 获取表头
     */
    getTitle = () => {
        const { roleMap } = this.props;
        const { dataSource } = this.state;
        const { firstname, lastname, uhead, uroleid } = dataSource;
        let logo = uhead ? (typeof uhead === 'string') ? JSON.parse(uhead) : uhead : '';
        return this.getAvatar({
            ...{
                roleName: roleMap == 'ib' ? 'ib' : roleMap && roleMap[uroleid],
                firstName: firstname,
                lastName: lastname,
                uhead: logo && logo.url ? logo.url : logo,
                showUser: true
            }
        });
    };

    /**
     * 监听事件
     */
    handleVisibleChange = () => {
        const { dataSource } = this.state;
        !dataSource.uuid && this.intlData();
    };

    /**
     * 打开crm详情
     */
    openDetails = () => {
        const { link, type, status: { utype: curUtype } } = this.props;
        const { dataSource } = this.state;
        let url = (curUtype === 'admin' ? {
            'client': `/client/account/crm/detail/${dataSource.uuid}`,
            'ib': `/client/account/crm/detail/${dataSource.uuid}`,
            'sales': `/sales/manager/list/detail/${dataSource.uuid}`,
            'admin': `/setting/authority/admin/detail/${dataSource.uuid}`
        } : {
            'client': `/client/manager/list/detail/${dataSource.uuid}`,
            'ib': `/client/manager/list/detail/${dataSource.uuid}`,
            'sales': `/team/manager/sales/detail/${dataSource.uuid}`,
            'admin': `/setting/authority/admin/detail/${dataSource.uuid}`
        } as any)[type];
        window.open(link || url);
    };

    render() {
        const items = this.getConfig();
        const { trigger = 'click', children } = this.props;
        const { dataSource, isLoading } = this.state;
        const { firstname, lastname } = dataSource;
        return (
            <Popover overlayClassName='Client-Popover' title={this.getTitle()} trigger={trigger} content={
                <Loading enabled={isLoading}>
                    <Row justify="start" gutter={32}>{items.map((item: any) => {
                        const { key, value, label, Extra } = item;
                        return (
                            <Col key={key} span={12}>
                                <span className='Client-Popover-label ellipsis' title={label}>{label}</span>
                                <span className='Client-Popover-value'>{value}</span>
                                {Extra && <span className='Client-Popover-extra'>{Extra(value)}</span>}
                            </Col>
                        );
                    })}<Col key="hide" span={12} /></Row>
                    <section className='Client-Popover-footer'>
                        <LoginOutlined onClick={this.openDetails} />
                    </section>
                </Loading>
            } overlayStyle={{ width: 550 }} onVisibleChange={this.handleVisibleChange}>
                {children || <a style={{ cursor: "pointer" }}>{intl.get('Global.Name', {
                    firstName: firstname,
                    lastName: lastname
                })}</a>}
            </Popover>
        );
    }
}
